import React, { useMemo } from 'react';

import { IntegrationsConnection } from '@shipstation/connections-ui';
import { DirectIntegrationsConnection } from '@shipstation/connections-ui/direct';
import { noop } from 'ui-components/default-props/noop';

import { useEnableDirectCuiIntegrations } from '../feature-flags/hooks/use-enable-direct-cui-integrations';
import { useCommonCuiProps } from './helpers/use-common-cui-props';
import { useCuiApiConfig } from './helpers/use-cui-api-config';
import { useCuiContextProps } from './helpers/use-cui-context-props';
import styles from './integrations-container.module.less';

type Props = {
  integrationAppId: number;
  onRedirect?: (...args: unknown[]) => unknown;
};

export const CuiIntegrationsConnection = ({ integrationAppId, onRedirect = noop }: Props) => {
  const isDirectMode = useEnableDirectCuiIntegrations();
  const commonCuiProps = useCommonCuiProps();
  const cuiApiConfig = useCuiApiConfig();
  const cuiContextProps = useCuiContextProps();

  const directContextProps = useMemo(() => ({ ...cuiContextProps, onRedirect }), [cuiContextProps, onRedirect]);

  if (isDirectMode) {
    return (
      <div className={styles.containerDirect}>
        <DirectIntegrationsConnection apiConfig={cuiApiConfig} contextProps={directContextProps} integrationAppId={integrationAppId} />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <IntegrationsConnection {...commonCuiProps} integrationAppId={integrationAppId} />
    </div>
  );
};
